import { ShoppingBagFilters } from '@models/ShoppingBagFilters';
import * as api from './api';

export function get(integrationId: number, filters?: ShoppingBagFilters) {
  return api.get(`shopping-bag/representative/open/${integrationId}`, { ...filters, fullData: false });
}
